import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { EnvService } from './env.service';
import { CallBackTransformService } from './call-back-transform.service';
import { LocalStorageService } from './local-storage.service';
import { localStorageConstants } from '../localStorageConstants/localStorageConstants';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LookupService {
  private  showOverlaySubject = new BehaviorSubject(false);
  public showOverlay = this.showOverlaySubject.asObservable();
  private  isActiveModalSubject = new BehaviorSubject(false);
  public isActiveModal = this.isActiveModalSubject.asObservable();
  public emailLanguageSubject = new BehaviorSubject<any>(null);
  constructor(
    private envService: EnvService,
    private http: HttpClient,
    private callBackTransformService: CallBackTransformService,
    private localStorageService: LocalStorageService, private location: Location
  ) { }

  /**
   * Api to retreve questionnaire
   */
  getAllQuestionnaire(): Observable<any> {
    const url = this.envService.apiUrl + 'questionnaire';
    return this.http.get<any>(url).pipe(
      map((data) => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError((error) => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }
  /**
   * Api to retrieve states
   */
  getCountryStates(): Observable<any> {
    const countryStates = this.localStorageService.getFromLocalStorage(localStorageConstants.countryStates);
    if (countryStates == null || countryStates.length === 0) {
      const url = this.envService.apiUrl + 'country-states';
      return this.http.get<any>(url).pipe(
        map((data) => {
          this.localStorageService.saveInLocalStorage(localStorageConstants.countryStates,
            JSON.stringify(this.callBackTransformService.transformOutput(data)));
          return this.callBackTransformService.transformOutput(data);
        }),
        catchError((error) => {
          return throwError(this.callBackTransformService.transformOutput(error));
        })
      );
    } else {
      const result = new Observable((observer) => {
        observer.next(countryStates);
      });
      return result;
    }
  }
  /**
   * Api to retrieve level
   */
  getAllLevels(): Observable<any> {
      const url = this.envService.apiUrl + 'collaboration-levels';
      return this.http.get<any>(url).pipe(
        map((data) => {
          return this.callBackTransformService.transformOutput(data);
        }),
        catchError((error) => {
          return throwError(this.callBackTransformService.transformOutput(error));
        })
      );
  }
  /**
   * Api to retrieve types
   */
  getAllTherapyTypes(): Observable<any> {
    const collaborationTypes = this.localStorageService.getFromLocalStorage(localStorageConstants.collaborationTypes);
    if (collaborationTypes == null || collaborationTypes.length === 0) {
      const url = this.envService.apiUrl + 'collaboration-types';
      return this.http.get<any>(url).pipe(
        map((data) => {
          this.localStorageService.saveInLocalStorage(localStorageConstants.collaborationTypes,
            JSON.stringify(this.callBackTransformService.transformOutput(data)));
          return this.callBackTransformService.transformOutput(data);
        }),
        catchError((error) => {
          return throwError(this.callBackTransformService.transformOutput(error));
        })
      );
    } else {
      const result = new Observable((observer) => {
        observer.next(collaborationTypes);
      });
      return result;
    }
  }
  /**
   * Api to retrieve leads
   */
  getAllLeads(): Observable<any> {
    const collaborationLeads = this.localStorageService.getFromLocalStorage(localStorageConstants.collaborationLeads);
    if (collaborationLeads == null || collaborationLeads.length === 0) {
      const url = this.envService.apiUrl + 'collaboration-leads';
      return this.http.get<any>(url).pipe(
        map((data) => {
          this.localStorageService.saveInLocalStorage(localStorageConstants.collaborationLeads,
            JSON.stringify(this.callBackTransformService.transformOutput(data)));
          return this.callBackTransformService.transformOutput(data);
        }),
        catchError((error) => {
          return throwError(this.callBackTransformService.transformOutput(error));
        })
      );
    } else {
      const result = new Observable((observer) => {
        observer.next(collaborationLeads);
      });
      return result;
    }
  }
  /**
   * Api to retrieve categories
   */
  GetAllCategories(): Observable<any> {
    const category = this.localStorageService.getFromLocalStorage(localStorageConstants.category);
    if (category == null || category.length === 0) {
      const url = this.envService.apiUrl + 'category';
      return this.http.get<any>(url).pipe(
        map((data) => {
          this.localStorageService.saveInLocalStorage(localStorageConstants.category,
            JSON.stringify(this.callBackTransformService.transformOutput(data)));
          return this.callBackTransformService.transformOutput(data);
        }),
        catchError((error) => {
          return throwError(this.callBackTransformService.transformOutput(error));
        })
      );
    } else {
      const result = new Observable((observer) => {
        observer.next(category);
      });
      return result;
    }
  }
  /**
   * Api to retreve sexuality
   */
  getAllSexuality(): Observable<any> {
    const sexuality = this.localStorageService.getFromLocalStorage(localStorageConstants.sexuality);
    if (sexuality == null || sexuality.length === 0) {
      const url = this.envService.apiUrl + 'sexuality';
      return this.http.get<any>(url).pipe(
        map((data) => {
          this.localStorageService.saveInLocalStorage(localStorageConstants.sexuality,
            JSON.stringify(this.callBackTransformService.transformOutput(data)));
          return this.callBackTransformService.transformOutput(data);
        }),
        catchError((error) => {
          return throwError(this.callBackTransformService.transformOutput(error));
        })
      );
    } else {
      const result = new Observable((observer) => {
        observer.next(sexuality);
      });
      return result;
    }
  }
  /**
   * Api to retrieve gender
   */
  getAllGender(): Observable<any> {
    const gender = this.localStorageService.getFromLocalStorage(localStorageConstants.gender);
    if (gender == null || gender.length === 0) {
      const url = this.envService.apiUrl + 'gender';
      return this.http.get<any>(url).pipe(
        map((data) => {
          this.localStorageService.saveInLocalStorage(localStorageConstants.gender,
            JSON.stringify(this.callBackTransformService.transformOutput(data)));
          return this.callBackTransformService.transformOutput(data);
        }),
        catchError((error) => {
          return throwError(this.callBackTransformService.transformOutput(error));
        })
      );
    } else {
      const result = new Observable((observer) => {
        observer.next(gender);
      });
      return result;
    }
  }
  /**
   * Api to retreve Ethnicity
   */
  getAllRaceEthnicity(): Observable<any> {
    const raceEthnicity = this.localStorageService.getFromLocalStorage(localStorageConstants.raceEthnicity);
    if (raceEthnicity == null || raceEthnicity.length === 0) {
      const url = this.envService.apiUrl + 'race-ethnicity';
      return this.http.get<any>(url).pipe(
        map((data) => {
          this.localStorageService.saveInLocalStorage(localStorageConstants.raceEthnicity,
            JSON.stringify(this.callBackTransformService.transformOutput(data)));
          return this.callBackTransformService.transformOutput(data);
        }),
        catchError((error) => {
          return throwError(this.callBackTransformService.transformOutput(error));
        })
      );
    } else {
      const result = new Observable((observer) => {
        observer.next(raceEthnicity);
      });
      return result;
    }
  }

  /**
   * Api to retreve IdentificationType
   */
  getAllIdentificationType(agencyId?:number): Observable<any> {
      const url = this.envService.apiUrl + 'identification-types';
      const updateUrl = agencyId ? url +'?agencyId=' + agencyId : url;
      return this.http.get<any>(updateUrl).pipe(
        map((data) => {
          this.localStorageService.saveInLocalStorage(localStorageConstants.identificationTypes,
            JSON.stringify(this.callBackTransformService.transformOutput(data)));
          return this.callBackTransformService.transformOutput(data);
        }),
        catchError((error) => {
          return throwError(this.callBackTransformService.transformOutput(error));
        })
      );
  }


  /**
   * Api to retrieve languages
   */
  getAllLanguages(): Observable<any> {
    const languages = this.localStorageService.getFromLocalStorage(localStorageConstants.languages);
    if (languages == null || languages.length === 0) {
      const url = this.envService.apiUrl + 'languages';
      return this.http.get<any>(url).pipe(
        map((data) => {
          this.localStorageService.saveInLocalStorage(localStorageConstants.languages,
            JSON.stringify(this.callBackTransformService.transformOutput(data)));
          return this.callBackTransformService.transformOutput(data);
        }),
        catchError((error) => {
          return throwError(this.callBackTransformService.transformOutput(error));
        })
      );
    } else {
      const result = new Observable((observer) => {
        observer.next(languages);
      });
      return result;
    }
  }
  /**
   * Api to retreve agencies
   */
  getAgencies(): Observable<any> {
    const url = this.envService.apiUrl + 'agency/lookup';
    return this.http.get<any>(url).pipe(
      map((data) => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError((error) => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }

  /**
 * Api to retreve all agencies
 */
  getAllAgencies(): Observable<any> {
    const url = this.envService.apiUrl + 'agency/GetAllAgencies';
    return this.http.get<any>(url).pipe(
      map((data) => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError((error) => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }

  /**
   * Api to retreve all collaborations
   */
  getAllAgencyCollborations(agencyid): Observable<any> {
    const url = this.envService.apiUrl + 'AgencyCollaboration/' + agencyid;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError((error) => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }

  /**
   * Api to retreve roles
   */
  getAllRoles(): Observable<any> {
    const roles = this.localStorageService.getFromLocalStorage(localStorageConstants.roles);
    if (roles == null || roles.length === 0) {
      const url = this.envService.apiUrl + 'roles';
      return this.http.get<any>(url).pipe(
        map((data) => {
          this.localStorageService.saveInLocalStorage(localStorageConstants.roles,
            JSON.stringify(this.callBackTransformService.transformOutput(data)));
          return this.callBackTransformService.transformOutput(data);
        }),
        catchError((error) => {
          return throwError(this.callBackTransformService.transformOutput(error));
        })
      );
    } else {
      const result = new Observable((observer) => {
        observer.next(roles);
      });
      return result;
    }
  }

  /**
   * Api to retreve all supervisors
   */
  getAllSuperVisors(userId): Observable<any> {
    const url = this.envService.apiUrl + 'helper/lookup/' + userId;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError((error) => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }

  /**
   * Api to retreve all Reviewers
   */
  getAllReviewers(userId: any): Observable<any> {
    const url = this.envService.apiUrl + 'helper/lookup/' + userId;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError((error) => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }

  /**
   * Api to retreve all collaborations
   */
  getAllCollborations(): Observable<any> {
    const url = this.envService.apiUrl + 'collaboration/lookups';
    return this.http.get<any>(url).pipe(
      map((data) => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError((error) => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }

  /**
   * Api to retreve all Support type (Relationship)
   */
  getAllSupportType(params?): Observable<any> {
    const supportType = this.localStorageService.getFromLocalStorage(localStorageConstants.supportType);
    if (supportType == null || supportType.length === 0) {
      const url = this.envService.apiUrl + 'support-type';
      return this.http.get<any>(url,{params}).pipe(
        map((data) => {
          this.localStorageService.saveInLocalStorage(localStorageConstants.supportType,
            JSON.stringify(this.callBackTransformService.transformOutput(data)));
          return this.callBackTransformService.transformOutput(data);
        }),
        catchError((error) => {
          return throwError(this.callBackTransformService.transformOutput(error));
        })
      );
    } else {
      const result = new Observable((observer) => {
        observer.next(supportType);
      });
      return result;
    }
  }
  /**
   * Api to retreve all notification levels
   */
  getAllNotificationLevel(): Observable<any> {
    const notificationLevel = this.localStorageService.getFromLocalStorage(localStorageConstants.notificationLevel);
    if (notificationLevel == null || notificationLevel.length === 0) {
      const url = this.envService.apiUrl + 'notification-level';
      return this.http.get<any>(url).pipe(
        map((data) => {
          this.localStorageService.saveInLocalStorage(localStorageConstants.notificationLevel,
            JSON.stringify(this.callBackTransformService.transformOutput(data)));
          return this.callBackTransformService.transformOutput(data);
        }),
        catchError((error) => {
          return throwError(this.callBackTransformService.transformOutput(error));
        })
      );
    } else {
      const result = new Observable((observer) => {
        observer.next(notificationLevel);
      });
      return result;
    }
  }
  /**
   * Api to retreve item response behaviour
   */
  getAllItemResponseBehavior(): Observable<any> {
    const url = this.envService.apiUrl + 'item-Response-Behavior';
    return this.http.get<any>(url).pipe(
      map((data) => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError((error) => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }
  getAlertNotificationType(): Observable<any> {
    const url = this.envService.apiUrl + 'alert-notification-type';
    return this.http.get<any>(url).pipe(
      map((data) => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError((error) => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }
  /**
   * Api to retrieve Title
   */
  getAllTitles(): Observable<any> {
    const titles = this.localStorageService.getFromLocalStorage(localStorageConstants.helperTitle);
    if (titles == null || titles.length === 0) {
      const url = this.envService.apiUrl + 'helper-title';
      return this.http.get<any>(url).pipe(
        map((data) => {
          this.localStorageService.saveInLocalStorage(localStorageConstants.helperTitle,
            JSON.stringify(this.callBackTransformService.transformOutput(data)));
          return this.callBackTransformService.transformOutput(data);
        }),
        catchError((error) => {
          return throwError(this.callBackTransformService.transformOutput(error));
        })
      );
    } else {
      const result = new Observable((observer) => {
        observer.next(titles);
      });
      return result;
    }
  }
  /**
   * Api to get Item-Response_behaivour
   */
  getAllResponse(qid) {
    const url = this.envService.apiUrl + 'response?qid='+ qid;
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
  }

  /**
   * Api to retreve sharingunits
   */
  getAccess(): Observable<any> {
    const url = this.envService.apiUrl + 'sharingunits';
    return this.http.get<any>(url).pipe(
      map((data) => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError((error) => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }

  /**
   * Api to retreve questionnaire items
   */
  getQuestionnaireItems(questionnaireId): Observable<any> {
    const url =
      this.envService.apiUrl + 'questionnaireitems/' + questionnaireId;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError((error) => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }

  /**
 * Api to retreve all notification types
 */
  getAllNotificationTypes(): Observable<any> {
    const notificationType = this.localStorageService.getFromLocalStorage(localStorageConstants.notificationType);
    if (notificationType == null || notificationType.length === 0) {
      const url = this.envService.apiUrl + 'notification-type';
      return this.http.get<any>(url).pipe(
        map(data => {
          this.localStorageService.saveInLocalStorage(localStorageConstants.notificationType,
            JSON.stringify(this.callBackTransformService.transformOutput(data)));
          return this.callBackTransformService.transformOutput(data);
        }),
        catchError(error => {
          return throwError(this.callBackTransformService.transformOutput(error));
        })
      );
    } else {
      const result = new Observable((observer) => {
        observer.next(notificationType);
      });
      return result;
    }
  }

  getBrandingDetails(): Observable<any> {
    const url = this.envService.apiUrl + 'agency-branding';
    return this.http.get<any>(url).pipe(
      map(data => {
        data.result.branding = JSON.parse(data?.result?.branding);
        let formattedData = this.callBackTransformService.transformOutput(data);
        this.localStorageService.saveInLocalStorage(localStorageConstants.configurationId, data?.result?.configurationID);
        this.localStorageService.saveInLocalStorage(localStorageConstants.brandingDetails, JSON.stringify(formattedData.Data));
        return formattedData;
      }),
      catchError(error => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }

  // getLanguages(): Observable<any> {
  //   const url = this.envService.apiUrl + 'Agency-Language';
  //   return this.http.get<any>(url).pipe(
  //     map((data) => {
  //       this.localStorageService.saveInLocalStorage('languageList', JSON.stringify(data));
  //       return this.callBackTransformService.transformOutput(data);
  //     }),
  //     catchError((error) => {
  //       return throwError(this.callBackTransformService.transformOutput(error));
  //     })
  //   );
  // }

  /**
* Api to retreve all notification types
*/
  getAllReason(): Observable<any> {
    const url = this.envService.apiUrl + 'assessment-reason';
    return this.http.get<any>(url).pipe(
      map(data => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError(error => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }
  /**
     * Api to retreve all country codes
     */
  getAllCountryCodes(): Observable<any> {
    const url = this.envService.apiUrl + 'countries';
    return this.http.get<any>(url).pipe(
      map(data => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError(error => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }
  /**
* Api to retreve all managers
*/
  getAllManagers(): Observable<any> {
    const url = this.envService.apiUrl + 'managers/';
    return this.http.get<any>(url).pipe(
      map((data) => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError((error) => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }
  /**
  * Api to retreve all timeperiod
  */
  GetTimePeriodDetails(daysInEpisode): Observable<any> {
    const url = this.envService.apiUrl + 'timeperiod/' + daysInEpisode;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError((error) => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }

  /**
   * Api to retrieve Identified gender
   */
  getAllIdentifiedGender(): Observable<any> {
    const identifiedGender = this.localStorageService.getFromLocalStorage(localStorageConstants.identifiedGender);
    if (identifiedGender == null || identifiedGender.length === 0) {
      const url = this.envService.apiUrl + 'identified-gender';
      return this.http.get<any>(url).pipe(
        map((data) => {
          this.localStorageService.saveInLocalStorage(localStorageConstants.identifiedGender,
            JSON.stringify(this.callBackTransformService.transformOutput(data)));
          return this.callBackTransformService.transformOutput(data);
        }),
        catchError((error) => {
          return throwError(this.callBackTransformService.transformOutput(error));
        })
      );
    } else {
      const result = new Observable((observer) => {
        observer.next(identifiedGender);
      });
      return result;
    }
  }

  /**
   * Api to retreve agencysharingpolicy
   */
  getAgencySharingPolicy(): Observable<any> {
    const url = this.envService.apiUrl + 'agencysharingpolicy';
    return this.http.get<any>(url).pipe(
      map((data) => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError((error) => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }

  /**
   * Api to retreve agencies
   */
  getSharingAgencies(): Observable<any> {
    const url = this.envService.apiUrl + 'agencyforsharing';
    return this.http.get<any>(url).pipe(
      map((data) => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError((error) => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }

  /**
   * Api to retreve agencies
   */
  getSharingAgenciesByAgency(): Observable<any> {
    const url = this.envService.apiUrl + 'agencyforsharing-by-agency';
    return this.http.get<any>(url).pipe(
      map((data) => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError((error) => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }

  /**
     * Api to retreve sharingunits
     */
  getCollaborationSharingPolicy(): Observable<any> {
    const url = this.envService.apiUrl + 'collaborationsharingpolicy';
    return this.http.get<any>(url).pipe(
      map((data) => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError((error) => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }

  getLanguages(): Observable<any> {
    const url = this.envService.apiUrl + 'Agency-Language';
    return this.http.get<any>(url).pipe(
      map((data) => {
        this.localStorageService.saveInLocalStorage('languageList', JSON.stringify(data));
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError((error) => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }
   getAnonymousLanguages(): Observable<any> {
    const url = this.envService.apiUrl + 'Agency-Language-Anonymous';
    return this.http.get<any>(url).pipe(
      map((data) => {
        return this.callBackTransformService.transformOutput(data);
      }),
      catchError((error) => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }

  filterForAutoComplete(data, value, key) {
    const searchText = typeof (value) === 'string' ? value.toLowerCase() : value;
    return data.filter(val => val[key].toLowerCase().includes(searchText));
  }
  filterForAutoCompleteCombinedItems(data, value, key1, key2) {
    const searchText = typeof (value) === 'string' ? value.toLowerCase() : value;
    const array = [];
    data.forEach(element => {
      const text = element[key1] + element[key2];
      if (text.toLowerCase().includes(searchText)) {
        array.push(element);
      }
    });
    return array;
  }
  filterForAutoCompleteCombined(data, value, key1, key2, key3) {
    const searchText = typeof (value) === 'string' ? value.toLowerCase() : value;
    const array = [];
    data.forEach(element => {
      const text = element[key1] + element[key2] + element[key3];
      if (text.toLowerCase().includes(searchText)) {
        array.push(element);
      }
    });
    return array;

  }

  getDefaultBrandingDetails(agencyId): Observable<any> {
    const url = this.envService.apiUrl + 'agency-branding?agencyId=' + agencyId;
    return this.http.get<any>(url).pipe(
      map((data) => {
        data.result.branding = JSON.parse(data?.result?.branding);
        let formattedData = this.callBackTransformService.transformOutput(data);
        this.localStorageService.saveInLocalStorage(localStorageConstants.defaultConfigurationId, data?.result?.configurationID);
        this.localStorageService.saveInLocalStorage(localStorageConstants.defaultBranding, JSON.stringify(formattedData.Data));
        return formattedData;
      }),
      catchError(error => {
        return throwError(this.callBackTransformService.transformOutput(error));
      })
    );
  }
  updateOverlayState(showOverlay) {
    this.showOverlaySubject.next(showOverlay);
}
removeHelperIdFromAgency(id){
    const url = this.envService.apiUrl + 'default-helper/' + id;
    return this.http.delete(url).pipe(
      map(output => {
        return this.callBackTransformService.transformOutput(output);
      }),
      catchError(err => {
        return throwError(this.callBackTransformService.transformOutput(err));
      })
    );
}
updateQueryParams(params: { [key: string]: any },removeParams?: { [key: string]: any } | string[]
) {
  const queryParams = new URLSearchParams(window.location.search);
  if (removeParams) {
    const keysToRemove = Array.isArray(removeParams)
      ? removeParams
      : Object.keys(removeParams);
    keysToRemove.forEach((key) => {
      queryParams.delete(key);
    });
  }
  if (params) {
    Object.keys(params).forEach((key) => queryParams.set(key, params[key]));
  }
  this.location.replaceState(this.location.path().split('?')[0], queryParams.toString());
}
updateActiveModalState(ismodalOpen) {
  this.isActiveModalSubject.next(ismodalOpen);
}
setEmailLanguage(lang: string) {
    this.emailLanguageSubject.next(lang);
}
}
